module.exports = {"restOfWorld":"Rest of the World","alone":"Anywhere in the World","withOthers":"Everywhere Else"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsQuotes.json
// module id = 1808
// module chunks = 4 14